import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import type { FormikState, FormikValues } from 'formik';

import ProductFormFields from '../ProductFormFields';
import ProductForm from '../ProductForm';
import { useNotification } from 'shared/Notification';
import AddToBasket from './AddToBasket';
import type { ICropFormikProduct } from 'types/product';

export default function AddProduct() {
  const [{ value: products = [] }, , { setValue }] = useField('products');
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });
  const { notification } = useNotification();

  const addNewProduct = useCallback(
    async (newProduct: ICropFormikProduct) => {
      const existingProduct = products.find(
        ({ packagedItemReference }) => newProduct.packagedItemReference === packagedItemReference,
      );

      // Add product quantities if it is an existing product in the basket
      await setValue(
        existingProduct
          ? [
              {
                ...existingProduct,
                packagedItemQty: existingProduct.packagedItemQty + newProduct.packagedItemQty,
              },
              ...products.filter(
                ({ packagedItemReference }) =>
                  newProduct.packagedItemReference !== packagedItemReference,
              ),
            ]
          : [newProduct, ...products],
      );
    },
    [products, setValue],
  );

  const handleSubmit = useCallback(
    async (values, resetForm?: (nextState?: Partial<FormikState<FormikValues>>) => void) => {
      await addNewProduct(values);
      notification(t('notifications.productWasAdded'), 'success');

      if (resetForm) resetForm();
    },
    [addNewProduct, notification, t],
  );
  return (
    <ProductFormFields onSubmit={handleSubmit}>
      <ProductForm actions={<AddToBasket />}></ProductForm>
    </ProductFormFields>
  );
}
